import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';

import { faTimes } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyboxResetButton',
  emits: ["reset"],
  setup(__props, { emit }: { emit: ({
	(e: 'reset'): void;
}), expose: any, slots: any, attrs: any }) {



const { tc } = useI18n();

function handleClick() {
	emit('reset');
}

return { __sfc: true,emit, tc, handleClick, faTimes }
}

})